import React, { Suspense } from "react";
import Page from "@jumbo/shared/Page";
import ProtectedRoutes from "../ProtectedRoutes";
import { ERPCustomLoader } from "app/shared/ReuseComponents/StyledComponents";

import Home from "../pages/home";
import HRMSDashboard from "../pages/home/Dashboard/RoleDashboard";
import Login from "app/pages/auth-pages/login/Login";
import ForgotPassword from "app/pages/auth-pages/forgot-password/ForgotPassword";
import ForgotPasswordForm from "app/pages/auth-pages/forgot-password/ForgotPasswordForm";
import RegistrationForm from "app/pages/hr/RolesAndUsers/RegistrationForm";


import ViewApprovalLeaves from "app/pages/hr/LeaveManagement/ApplyLeave/ViewApprovalLeaves";
import ViewTimesheets from "app/pages/hr/TimeManagement/ViewTimesheets";



import AuthGuard from "app/pages/auth-pages/login/AuthGuard";
import DocumentApprovalForHr from "app/pages/hr/DocumentApprovalForHr";
import DocumentUserApproval from "app/pages/UserPendingApprovals/DocumentUserApproval";
import { Tenantname } from "app/services/auth-services";



/**
 routes which you want to make accessible to both authenticated and anonymous users
 **/

// hr
const HRSettings = React.lazy(() => import("app/pages/hr/HRSettings"));
const PayrollCalenderList = React.lazy(() => import("app/pages/hr/PayrollManagement/PayrollProcessSettings/PayrollCalenderList"));
const EmployeeProvidentFund = React.lazy(() => import("app/pages/hr/statutory/EmployeeProvidentFund"));
const EmployeeStateInsurance = React.lazy(() => import("app/pages/hr/statutory/EmployeeStateInsurance"));
const ProfessionalTax = React.lazy(() => import("app/pages/hr/statutory/ProfessionalTax"));
const EarningList = React.lazy(() => import("app/pages/hr/statutory/salary/Earings/EarningList"));
const DeductionList = React.lazy(() => import("app/pages/hr/statutory/salary/Deductions/DeductionList"));
const ListEmployees = React.lazy(() => import("app/pages/hr/employee/ListEmployees"));
const ListDepartments = React.lazy(() => import("app/pages/hr/department/ListDepartments"));
const ListDesignations = React.lazy(() => import("app/pages/hr/designation/ListDesignations"));
const ListCadreLevels = React.lazy(() => import("app/pages/hr/cadrelevel/ListCadreLevels"));
const ListReimbursement = React.lazy(() => import("app/pages/hr/Reimbursement/ListReimbursement"));
const EmployeeClaimsList = React.lazy(() => import("app/pages/hr/EmployeeClaims/EmployeeClaimsList"));
const ListResignation = React.lazy(() => import("app/pages/hr/resignation/ListResignation"));
const EmployeeOrg = React.lazy(() => import("app/pages/hr/HrOperation/EmployeeOrganisation/EmployeeOrg"));
// const EmployeeOrg = React.lazy(() => import("app/pages/hr/HrOperation/EmployeeOrganisation/EmployeeOrg1"));

const EmployeeAdditionTrend = React.lazy(() => import("app/pages/hr/HrOperation/EmployeeAdditionTrend"));
const EmployeeAttritionTrend = React.lazy(() => import("app/pages/hr/HrOperation/EmployeeAttritionTrend"));
const CheckinStatus = React.lazy(() =>
  Tenantname === "relux"
    ? import("app/pages/hr/HrOperation/EmployeeCheckin/CheckinStatus")
    : import("app/pages/hr/HrOperation/EmployeeCheckin/CheckinStatusdemo")
);
const AbsentEmployees = React.lazy(() => import("app/pages/hr/HrOperation/AbsentEmployees"));
const LateCheckinEmployees = React.lazy(() => import("app/pages/hr/HrOperation/LateCheckinEmployees"));
const ListDeviceConfiguration = React.lazy(() => import("app/pages/hr/HrOperation/DeviceConfigurationSetup/ListDeviceConfiguration"));
const ListCheckin = React.lazy(() => import("app/pages/hr/HrOperation/EmployeeCheckin/ListCheckin"));
const ListESSCheckin = React.lazy(() => import("app/pages/hr/HrOperation/EmployeeCheckin/ListESSCheckin"));
const DepartmentWiseChart = React.lazy(() => import("app/pages/hr/HrOperation/DepartmentWiseChart"));
const ListLeaveManagement = React.lazy(() => import("app/pages/hr/LeaveManagement/LeaveType/ListLeaveManagement"));
const ListofLeaves = React.lazy(() => import("app/pages/hr/LeaveManagement/ApplyLeave/ListofLeaves"));
const ViewLeaves = React.lazy(() => import("app/pages/hr/LeaveManagement/ApplyLeave/ViewLeaves"));
const ListLeaveBalance = React.lazy(() => import("app/pages/hr/LeaveManagement/LeaveBalance/ListLeaveBalance"));
const ApplyLeave = React.lazy(() => import("app/pages/hr/LeaveManagement/ApplyLeave/ApplyLeave"));
const ListLeaveCancellation = React.lazy(() => import("app/pages/hr/LeaveManagement/LeaveCancellation/ListLeaveCancellation"));
const ListTimeManagement = React.lazy(() => import("app/pages/hr/TimeManagement/ListTimeManagement"));
const TimesheetLogs = React.lazy(() => import("app/pages/hr/TimeManagement/TimesheetLogs"));
const ApprovalTimesheets = React.lazy(() => import("app/pages/hr/TimeManagement/ApprovalTimesheets"));
const ProcessAttendance = React.lazy(() => import("app/pages/hr/AttendanceManagement/ProcessAttendance"));
const ConfigurationPayroll = React.lazy(() => import("app/pages/hr/PayrollManagement/ConfigurationPayroll"));
const LogAttendance = React.lazy(() => import("app/pages/hr/PayrollManagement/ProcessingPayroll/CreateAttendance"));
const ListPayrollData = React.lazy(() => import("app/pages/hr/PayrollManagement/ProcessingPayroll/CreatePayroll/ListPayrollData"));
const EarningVariableList = React.lazy(() => import("app/pages/hr/PayrollManagement/ProcessingPayroll/EarningVariables/EarningVariableList"));
const DeductionVariableList = React.lazy(() => import("app/pages/hr/PayrollManagement/ProcessingPayroll/DeductionVariables/DeductionVariableList"));
const ReversalLOPList = React.lazy(() => import("app/pages/hr/PayrollManagement/ProcessingPayroll/ReversalPayroll/ReversalLOPList"));
const ListofPayroll = React.lazy(() => import("app/pages/hr/PayrollManagement/ProcessingPayroll/ListofPayroll"));
const DraftPayroll = React.lazy(() => import("app/pages/hr/PayrollManagement/ProcessingPayroll/DraftPayroll"));
const PayslipSummary = React.lazy(() => import("app/pages/hr/PayrollManagement/ProcessingPayroll/PayslipSummary"));
const Payslip = React.lazy(() => import("app/pages/hr/PayrollManagement/Payslip/Payslip"));
const PayVoucherList = React.lazy(() => import("app/pages/hr/PayrollManagement/PayrollVoucher/PayVoucherList"));
const PDFforPayslip = React.lazy(() => import("app/pages/hr/PayrollManagement/PDFforPayslip"));
const PDFGenerator = React.lazy(() => import("app/pages/hr/PayrollManagement/PDFGenerator"));
const PayslipPDF = React.lazy(() => import("app/pages/hr/PayrollManagement/Payslip/PayslipPDF"));


// hr report
const Address = React.lazy(() => import("app/pages/hr/reports/AddressReport/Address"));
const Cashstatement = React.lazy(() => import("app/pages/hr/reports/CashStatementReport/Cashstatement"));
const BankStatement = React.lazy(() => import("app/pages/hr/reports/BankReport/BankStatement"));
const Deduction = React.lazy(() => import("app/pages/hr/reports/DeductionReport/Deduction"));
const ESIReport = React.lazy(() => import("app/pages/hr/reports/ESIReport/ESIReport"));
const PFReports = React.lazy(() => import("app/pages/hr/reports/PFReport/PFReports"));
const ProfessionalTaxReport = React.lazy(() => import("app/pages/hr/reports/PTReport/ProfessionalTaxReport"));
const GrossSalary = React.lazy(() => import("app/pages/hr/reports/GrossSalaryReport/GrossSalary"));
const LeaveReport = React.lazy(() => import("app/pages/hr/reports/LeaveReport/LeaveReport"));
const LeaveRegisterReport = React.lazy(() => import("app/pages/hr/reports/LeaveReport/LeaveRegisterReport"));

const Attendance = React.lazy(() => import("app/pages/hr/reports/AttendanceReport/Attendance"));
const EmployeeDetails = React.lazy(() => import("app/pages/hr/reports/EmployeeReport/EmployeeDetails"));
const Employeemaster = React.lazy(() => import("app/pages/hr/reports/EmployeeMasterReport/Employeemaster"));
const Earning = React.lazy(() => import("app/pages/hr/reports/EarningDeductionReport/Earning"));
const ListFullandFinalSettlement = React.lazy(() => import("app/pages/hr/FullandFinalSettlement/ListFullandFinalSettlement"));
const Taxforcast = React.lazy(() => import("app/pages/hr/reports/Taxforcast"));
const AppraisalReport = React.lazy(() => import("app/pages/hr/reports/AppraisalReport/AppraisalReport"));
const TrainingReport = React.lazy(() => import("app/pages/hr/reports/TrainingReport/TrainingReport"));
const AttendanceDetails = React.lazy(() => import("app/pages/hr/reports/AttendanceReport/AttendanceDetails"));
const AbsentStatement = React.lazy(() => import("app/pages/hr/reports/AbsentStatement/AbsentStatement"));
const AttendanceForm = React.lazy(() => import("app/pages/hr/reports/AttendanceReport/AttendanceForm"));
const TimesheetStatement = React.lazy(() => import("app/pages/hr/reports/TimesheetReport/TimesheetStatement"));
const PayrollStatement = React.lazy(() => import("app/pages/hr/reports/PayrollReport/PayrollStatement"));
const MonthlyIncomeTaxReport = React.lazy(() => import("app/pages/hr/reports/IncomeFormReport/MonthlyIncomeTaxReport"));
const Form3AReport = React.lazy(() => import("app/pages/hr/reports/IncomeFormReport/Form3AList"));
const Form6AReport = React.lazy(() => import("app/pages/hr/reports/IncomeFormReport/Form6AList"));
const Form16Report = React.lazy(() => import("app/pages/hr/reports/IncomeFormReport/Form16List"));
const Form16AReport = React.lazy(() => import("app/pages/hr/reports/IncomeFormReport/Form16AList"));


// settings
const GeneralSettings = React.lazy(() => import("app/pages/settings/GeneralSettings"));
const EditCompanyDetails = React.lazy(() => import("app/pages/settings/company/EditCompanyDetails"));
const TransactionApproval = React.lazy(() => import("app/pages/settings/TransactionApproval"));
const TransactionSeries = React.lazy(() => import("app/pages/settings/Preferences/TransactionSeries"));
const ListMailConfiguration = React.lazy(() => import("app/pages/settings/MailConfiguration/ListMailConfiguration"));
const PreferenceItems = React.lazy(() => import("app/pages/settings/Preferences/PreferenceItems"));
const SalesOrder = React.lazy(() => import("app/pages/settings/Preferences/SalesOrder"));
const Invoice = React.lazy(() => import("app/pages/settings/Preferences/Invoice"));
const Templates = React.lazy(() => import("app/pages/settings/templates/Templates"));
const SettingInventory = React.lazy(() => import("app/pages/settings/Preferences/Inventory"));
const PurchaseOrderSetting = React.lazy(() => import("app/pages/settings/Preferences/PurchaseOrderSetting"));
const NotificationContent = React.lazy(() => import("app/pages/settings/NotificationContent/NotificationContent"));
const SmsTemplateList = React.lazy(() => import("app/pages/settings/SmsTemplate/SmsTemplateList"));
const YearEndProcessBox = React.lazy(() => import("app/pages/settings/YearEndProcess/YearEndProcessBox"));
const ListTDS = React.lazy(() => import("app/pages/settings/TDSsetup/ListTDS"));
const RolesList = React.lazy(() => import("app/pages/hr/RolesAndUsers/RolesList"));
const UsersList = React.lazy(() => import("app/pages/hr/RolesAndUsers/UsersList"));
const BudgetLock = React.lazy(() => import("app/pages/settings/Preferences/BudgetLock"));
const ItemLookupCategory = React.lazy(() => import("app/pages/settings/lookup/ItemLookupCategory"));
const ListCostCentre = React.lazy(() => import("app/pages/settings/costcentre/ListCostCentre"));
const ListAccountPeriod = React.lazy(() => import("app/pages/settings/AccountPeriod/ListAccountPeriod"));
const ListTemplates = React.lazy(() => import("app/pages/settings/templates/ListTemplates"));
const HolidayLists = React.lazy(() => import("app/pages/settings/Holidays/HolidayLists"));
const OrganizationStructure = React.lazy(() => import("app/pages/settings/Organization/OrganizationStructure"));
const BudgetPreference = React.lazy(() => import("app/pages/settings/Preferences/BudgetPreference"));
const WorkflowAssignment = React.lazy(() => import("app/pages/settings/Workflow/WorkflowAssignment"));
const WorkflowList = React.lazy(() => import("app/pages/settings/Workflow/Workflows/WorkflowList"));
const ListAssignWorkflows = React.lazy(() => import("app/pages/settings/Workflow/AssignWorkflow/ListAssignWorkflows"));
const ListPartnerWorkflow = React.lazy(() => import("app/pages/settings/Workflow/PartnerWorkflow/ListPartnerWorkflow"));
const ListWorkflowRules = React.lazy(() => import("app/pages/settings/Workflow/WorkflowRules/ListWorkflowRules"));
const Authapprovals = React.lazy(() => import("app/pages/UserPendingApprovals/Authapprovals"));

const TallyXMLList = React.lazy(() => import("app/pages/TallyXMLList"));
const ChatandSupport = React.lazy(() => import("app/shared/widgets/AuthUserDropdown/ChatandSupport"));

const GoalList = React.lazy(() => import("app/pages/hr/Apprisal/Goal/GoalList"));
const ListAppraisals = React.lazy(() => import("app/pages/hr/Apprisal/Appraisal/ListAppraisals"));
const ListKPI = React.lazy(() => import("app/pages/hr/Apprisal/KPI/ListKPI"));
const FinalEvaluation = React.lazy(() => import("app/pages/hr/Apprisal/FinalEvaluation/ListFinalEvaluation"));
const ListPerformanceImprovement = React.lazy(() => import("app/pages/hr/Apprisal/PerformanceImprovement/ListPerformanceImprovement"));
const ListGoalSetting = React.lazy(() => import("app/pages/hr/Apprisal/SettingGoal/ListGoalSetting"));


const ListTraining = React.lazy(() => import("app/pages/hr/Training/TrainingDetails/ListTraining"));
const ListTrainer = React.lazy(() => import("app/pages/hr/Training/TrainerInformation/ListTrainer"));
const ListTrainingSchedule = React.lazy(() => import("app/pages/hr/Training/TraininSchedule/ListTrainingSchedule"));
const ListTargetAudience = React.lazy(() => import("app/pages/hr/Training/TargetAudience/ListTargetAudience"));
const ListTrainingContent = React.lazy(() => import("app/pages/hr/Training/TrainingContent/ListTrainingContent"));
const ListAttendance = React.lazy(() => import("app/pages/hr/Training/Attendance/ListAttendance"));
const ListofFeedBack = React.lazy(() => import("app/pages/hr/Training/FeedBack/ListofFeedBack"));
const ListCostBudget = React.lazy(() => import("app/pages/hr/Training/CostBudget/ListCostBudget"));


const ListSlabConfiguration = React.lazy(() => import("app/pages/hr/Incometax/SlabConfiguration/ListSlabConfiguration"));
const ListTaxSection = React.lazy(() => import("app/pages/hr/Incometax/TaxSections/ListTaxSection"));
const ListTaxExemptions = React.lazy(() => import("app/pages/hr/Incometax/TaxExemptions/ListTaxExemptions"));
const ListTaxDeductions = React.lazy(() => import("app/pages/hr/Incometax/TaxDeductions/ListTaxDeductions"));
const ListTaxDeclaration = React.lazy(() => import("app/pages/hr/Incometax/TaxDeclaration/ListTaxDeclaration"));
const ListTaxCalculation = React.lazy(() => import("app/pages/hr/Incometax/TaxCalculation/ListTaxCalculation"));


// ------------------------------------UserAdminPages-----------------------------------//
const AdminDashboard = React.lazy(() => import("app/pages/UserAdminPages/home/Admin-Dashboard"));
const AdminEmailLists = React.lazy(() => import("app/pages/UserAdminPages/mail/EmailLists"));
const ListLicence = React.lazy(() => import("app/pages/UserAdminPages/licence/AdditionalLicence/ListLicence"));
const CreateLicence = React.lazy(() => import("app/pages/UserAdminPages/licence/AdditionalLicence/CreateLicence"));
const ListStorage = React.lazy(() => import("app/pages/UserAdminPages/licence/Storage/ListStorage"));
const CreateStorage = React.lazy(() => import("app/pages/UserAdminPages/licence/Storage/CreateStorage"));
const ListAddonPurchase = React.lazy(() => import("app/pages/UserAdminPages/licence/AddonPurchase/ListAddonPurchase"));
const CreateAddonPurchase = React.lazy(() => import("app/pages/UserAdminPages/licence/AddonPurchase/CreateAddonPurchase"));
const CancelPlans = React.lazy(() => import("app/pages/UserAdminPages/licence/CancelPlan/CancelPlans"));
const ListRenewal = React.lazy(() => import("app/pages/UserAdminPages/licence/Renewal/ListRenewal"));
const ListLookup = React.lazy(() => import("app/pages/UserAdminPages/lookup/ListLookup"));
const CreateLookup = React.lazy(() => import("app/pages/UserAdminPages/lookup/CreateLookup"));
const ListTickets = React.lazy(() => import("app/pages/UserAdminPages/ticket/ListTickets"));
const CreateTickets = React.lazy(() => import("app/pages/UserAdminPages/ticket/CreateTickets"));
const ViewTicketResponse = React.lazy(() => import("app/pages/UserAdminPages/ticket/ViewTicketResponse"));
const DeveloperTicket = React.lazy(() => import("app/pages/UserAdminPages/ticket/Developeticket"));
const CreatedTicketList = React.lazy(() => import("app/pages/UserAdminPages/ticket/CreatedTicketList"));
const TicketsManagementGroup = React.lazy(() => import("app/pages/UserAdminPages/ticket/TicketManagement"));

//-----------------------Task Management for UserAdminPages-----------------------------------//
const ListTaskManagement = React.lazy(() => import("app/pages/UserAdminPages/taskmanagement/ListTaskManagement"));
const UpdateTask = React.lazy(() => import("app/pages/UserAdminPages/taskmanagement/UpdateTask"));
const AssignTaskLists = React.lazy(() => import("app/pages/UserAdminPages/taskmanagement/AssignTaskLists"));
const TaskCalendarView = React.lazy(() => import("app/pages/UserAdminPages/taskmanagement/TaskCalendarView"));



const routesForPublic = [
  // {
  //     path: "/",
  //     element: <Page component={Login} />,
  //     target: "_blank"
  // },
  {
    path: "/home",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={AuthGuard(Home)} />
      </Suspense>
  },

  {
    path: "/HRMSDashboard",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={AuthGuard(HRMSDashboard)} />
      </Suspense>
  },


  // HR menu urls
  {
    path: "/hr-settings",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={HRSettings} />
      </Suspense>
  },

  {
    path: "/hr-payroll-settings",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={PayrollCalenderList} />
      </Suspense>
  },

  {
    path: "/hr/employee-provident-fund",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={EmployeeProvidentFund} />
      </Suspense>
  },

  {
    path: "/hr/employee-state-insurance",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={EmployeeStateInsurance} />
      </Suspense>
  },
  {
    path: "/hr/professional-tax",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ProfessionalTax} />
      </Suspense>
  },

  {
    path: "/hr/salary-earnings",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={EarningList} />
      </Suspense>
  },

  {
    path: "/hr/salary-deductions",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={DeductionList} />
      </Suspense>
  },

  {
    path: "/hr/list-employee",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ListEmployees} />
      </Suspense>
  },

  {
    path: "/hr/list-department",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ListDepartments} />
      </Suspense>
  },

  {
    path: "/hr/list-designation",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ListDesignations} />
      </Suspense>
  },

  {
    path: "/hr/list-cadre-level",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ListCadreLevels} />
      </Suspense>
  },


  // new added
  {
    path: "/hr/list-Reimbursement",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ListReimbursement} />
      </Suspense>
  },
  // new added
  {
    path: "/hr/EmployeeClaimsList",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={EmployeeClaimsList} />
      </Suspense>
  },
  // new added on 17-06-2024
  {
    path: "/hr/list-Resignation",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ListResignation} />
      </Suspense>
  },

  // new added
  {
    path: "/hr/HrOperation/EmployeeOrganisation/EmployeeOrg",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={EmployeeOrg} />
      </Suspense>
  },
  {
    path: "/hr/HrOperation/EmployeeAdditionTrend",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={EmployeeAdditionTrend} />
      </Suspense>
  },
  {
    path: "/hr/HrOperation/EmployeeAttritionTrend",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={EmployeeAttritionTrend} />
      </Suspense>
  },
  {
    path: "/hr/HrOperation/CheckinStatus",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={CheckinStatus} />
      </Suspense>
  },
  {
    path: "/hr/AbsentEmployees",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={AbsentEmployees} />
      </Suspense>
  },
    {
    path: "/hr/LateCheckinEmployees",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={LateCheckinEmployees} />
      </Suspense>
  },
  {
    path: "/hr/HrOperation/DeviceConfiguration",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ListDeviceConfiguration} />
      </Suspense>
  },
  {
    path: "/hr/HrOperation/Checkinlists",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ListCheckin} />
      </Suspense>
  },
  {
    path: "/hr/CheckinlistsESS",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ListESSCheckin} />
      </Suspense>
  },
  {
    path: "/hr/HrOperation/DepartmentWiseChart",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={DepartmentWiseChart} />
      </Suspense>
  },

  // leave management menus
  {
    path: "/hr/list-leave-type",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ListLeaveManagement} />
      </Suspense>
  },
  {
    path: "/hr/list-of-leaves",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ListofLeaves} />
      </Suspense>
  },
  {
    path: "/hr/list-of-leave-calendar",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ViewLeaves} />
      </Suspense>
  },
  // new added
  {
    path: "/hr/list-leave-balance",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ListLeaveBalance} />
      </Suspense>
  },
  {
    path: "/hr/apply-leave",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ApplyLeave} />
      </Suspense>
  },
  //new added
  {
    path: "/hr/list-leave-cancellation",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ListLeaveCancellation} />
      </Suspense>
  },

  // time management menus
  {
    path: "/hr/list-time-management",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ListTimeManagement} />
      </Suspense>
  },
  {
    path: "/hr/timesheet-logs",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={TimesheetLogs} />
      </Suspense>
  },
  {
    path: "/hr/approval-timesheets",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ApprovalTimesheets} />
      </Suspense>
  },

  // attendance management menus
  {
    path: "/hr/create-attendance",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ProcessAttendance} />
      </Suspense>
  },

  // payroll management menus
  {
    path: "/hr/configuration-payroll",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ConfigurationPayroll} />
      </Suspense>
  },
  {
    path: "/hr/process-attendance",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={LogAttendance} />
      </Suspense>
  },
  {
    path: "/hr/payroll-data-processing",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ListPayrollData} />
      </Suspense>
  },


  // reversal components
  {
    path: "/hr/EarningsVariable",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={EarningVariableList} />
      </Suspense>
  },
  {
    path: "/hr/DeductionVariable",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={DeductionVariableList} />
      </Suspense>
  },
  {
    path: "/hr/ReversalLOP",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ReversalLOPList} />
      </Suspense>
  },


  {
    path: "/hr/list-of-payroll",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ListofPayroll} />
      </Suspense>
  },
  {
    path: "/hr/draft-payroll",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={DraftPayroll} />
      </Suspense>
  },

  {
    path: "/hr/payslip-summary",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={PayslipSummary} />
      </Suspense>
  },
  {
    path: "/hr/payslip",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={Payslip} />
      </Suspense>
  },
  {
    path: "/hr/pay-voucher",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={PayVoucherList} />
      </Suspense>
  },



  {
    path: "/hr/payslip_pdf", //add new
    element: <Page component={PDFforPayslip} layout={"solo-page"} />
  },

  {
    path: "/hr/payslip_generator", //add new
    element: <Page component={PDFGenerator} layout={"solo-page"} />
  },

  // new added document approval for hr module
  {
    path: "/hr/DocumentApprovalForHr", //add new
    element: <Page component={DocumentApprovalForHr} layout={"solo-page"} />
  },

  // for payslip pdf
  {
    path: "hr/payroll-payslip-pdf",
    element: <Page component={PayslipPDF} layout={"solo-page"} />
  },


  // new report urls
  // Hr Reports
  {
    path: "/hr/address",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={Address} />
      </Suspense>
  },
  {
    path: "/hr/cashstatement",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={Cashstatement} />
      </Suspense>
  },
  {
    path: "/hr/bankstatement",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={BankStatement} />
      </Suspense>
  },
  {
    path: "/hr/deduction",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={Deduction} />
      </Suspense>
  },
  {
    path: "/hr/esi",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ESIReport} />
      </Suspense>
  },
  {
    path: "/hr/pfreports",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={PFReports} />
      </Suspense>
  },
  {
    path: "/hr/ProfessionalTaxReport",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ProfessionalTaxReport} />
      </Suspense>
  },
  {
    path: "/hr/grosssalary",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={GrossSalary} />
      </Suspense>
  },
  {
    path: "/hr/leavereport",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={LeaveReport} />
      </Suspense>
  },
  {
    path: "/hr/LeaveRegisterReport",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={LeaveRegisterReport} />
      </Suspense>
  },
  {
    path: "/hr/attendancereport",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={Attendance} />
      </Suspense>
  },
  {
    path: "/hr/employeereport",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={EmployeeDetails} />
      </Suspense>
  },
  {
    path: "/hr/employeemaster",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={Employeemaster} />
      </Suspense>
  },
  {
    path: "/hr/earning",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={Earning} />
      </Suspense>
  },
  {
    path: "/hr/fullandfinal-settlement",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ListFullandFinalSettlement} />
      </Suspense>
  },
  {
    path: "/hr/taxforcast",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={Taxforcast} />
      </Suspense>
  },
  {
    path: "/hr/AppraisalReports",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={AppraisalReport} />
      </Suspense>
  },
  {
    path: "/hr/TrainingReports",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={TrainingReport} />
      </Suspense>
  },
  {
    path: "/hr/AttendanceDetails",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={AttendanceDetails} />
      </Suspense>
  },
  {
    path: "/hr/AbsentStatement",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={AbsentStatement} />
      </Suspense>
  },
  {
    path: "/hr/AttendanceForm",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={AttendanceForm} />
      </Suspense>
  },
  {
    path: "/hr/TimesheetStatement",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={TimesheetStatement} />
      </Suspense>
  },
  {
    path: "/hr/PayrollStatement",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={PayrollStatement} />
      </Suspense>
  },
  {
    path: "/hr/MonthlyIncomeTaxReport",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={MonthlyIncomeTaxReport} />
      </Suspense>
  },
  {
    path: "/hr/Form3AReport",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={Form3AReport} />
      </Suspense>
  },
  {
    path: "/hr/Form6AReport",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={Form6AReport} />
      </Suspense>
  },
  {
    path: "/hr/Form16Report",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={Form16Report} />
      </Suspense>
  },
  {
    path: "/hr/Form16AReport",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={Form16AReport} />
      </Suspense>
  },


  // settings submenu url
  {
    path: "/settings/general",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={GeneralSettings} />
      </Suspense>
  },
  {
    path: "/settings/edit-company-details",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={EditCompanyDetails} />
      </Suspense>
  },
  {
    path: "/settings/holiday-lists",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={HolidayLists} />
      </Suspense>
  },
  {
    path: "/settings/roles",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={RolesList} />
      </Suspense>
  },
  {
    path: "/settings/roles&users",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={UsersList} />
      </Suspense>
  },

  {
    path: "/settings/users/registration-form",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <Page component={RegistrationForm} layout={"solo-page"} />
      </Suspense>
  },

  {
    path: "/settings/transaction-approval",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={TransactionApproval} />
      </Suspense>
  },
  {
    path: "/settings/preferences/transaction-series", //inside of preference menu
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={TransactionSeries} />
      </Suspense>
  },
  {
    path: "/settings/ListMailConfiguration", //inside of preference menu
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ListMailConfiguration} />
      </Suspense>
  },
  {
    path: "/settings/preferences/items", //inside of preference menu
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={PreferenceItems} />
      </Suspense>
  },
  {
    path: "/settings/preferences/sales-order", //inside of preference menu
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={SalesOrder} />
      </Suspense>
  },
  {
    path: "/settings/preferences/invoice", //inside of preference menu
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={Invoice} />
      </Suspense>
  },
  {
    path: "/settings/preferences/purchase-order", //inside of preference menu
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={PurchaseOrderSetting} />
      </Suspense>
  },
  {
    path: "/settings/preferences/budget", //inside of preference menu
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={BudgetPreference} />
      </Suspense>
  },
{
    path: "/notification/content",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={NotificationContent} />
      </Suspense>
  },
  {
    path: "/settings/preferences/inventory", //inside of preference menu
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={SettingInventory} />
      </Suspense>
  },
  {
    path: "/settings/preferences/budgetlock", //inside of preference menu
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={BudgetLock} />
      </Suspense>
  },
  {
    path: "/settings/item-lookup-category", //inside of preference menu
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ItemLookupCategory} />
      </Suspense>
  },
  {
    path: "/settings/list-cost-centre", //inside of preference menu
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ListCostCentre} />
      </Suspense>
  },
  {
    path: "/settings/ListAccountPeriod", //inside of preference menu
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ListAccountPeriod} />
      </Suspense>
  },

  {
    path: "/setting/tdssetup",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ListTDS} />
      </Suspense>
  },
  {
    path: "/settings/YearEndProcess",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={YearEndProcessBox} />
      </Suspense>
  },

  {
    path: "/settings/SmsTemplate",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={SmsTemplateList} />
      </Suspense>
  },

  {
    path: "/settings/templates",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={Templates} />
      </Suspense>
  },

  {
    path: "/settings/list-templates",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ListTemplates} />
      </Suspense>
  },

  {
    path: "/settings/assign-workflow",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ListAssignWorkflows} />
      </Suspense>
  },

  {
    path: "/settings/partner-workflow",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ListPartnerWorkflow} />
      </Suspense>
  },

  {
    path: "/settings/workflow-rules",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ListWorkflowRules} />
      </Suspense>
  },

  {
    path: "/settings/workflow",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={WorkflowList} />
      </Suspense>
  },

  {
    path: "/settings/workflow-assignment",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={WorkflowAssignment} />
      </Suspense>
  },


  {
    path: "/settings/organization-structure",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={OrganizationStructure} />
      </Suspense>
  },


  // For User Approval
  {
    path: "/samples/content-layout",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={Authapprovals} />
      </Suspense>
  },

  // For Tally
  {
    path: "/tally",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={TallyXMLList} />
      </Suspense>
  },

  // For Chatbot
  {
    path: `ChatandSupport`,
    element: (
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ChatandSupport} />
      </Suspense>
    ),
  },


  //For Training

  {
    path: "/hr/Training_Details",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ListTraining} />
      </Suspense>
  },
  {
    path: "/hr/Trainer_Info",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ListTrainer} />
      </Suspense>
  },
  {
    path: "/hr/Training_Schedule",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ListTrainingSchedule} />
      </Suspense>
  },
  {
    path: "/hr/Target_Audience",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ListTargetAudience} />
      </Suspense>
  },
  {
    path: "/hr/Training_content",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ListTrainingContent} />
      </Suspense>
  },
  {
    path: "/hr/Training_Attendance",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ListAttendance} />
      </Suspense>
  }, {
    path: "/hr/Feedback",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ListofFeedBack} />
      </Suspense>
  },
  {
    path: "/hr/Budget",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ListCostBudget} />
      </Suspense>
  },
  //For Apprisal
  {
    path: "/hr/goal-list",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={GoalList} />
      </Suspense>
  },
  {
    path: "/hr/apprisal",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ListAppraisals} />
      </Suspense>
  },
  {
    path: "/hr/final-evaluation",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={FinalEvaluation} />
      </Suspense>
  },
  {
    path: "/hr/Performance-Improvement",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ListPerformanceImprovement} />
      </Suspense>
  },
  {
    path: "/hr/Setting-up-Goal",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ListGoalSetting} />
      </Suspense>
  },
  {
    path: "/hr/KPI",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ListKPI} />
      </Suspense>
  },
  {
    path: "/hr/Taxslab-configuration",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ListSlabConfiguration} />
      </Suspense>
  },
  {
    path: "/hr/Tax-Section",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ListTaxSection} />
      </Suspense>
  },
  {
    path: "/hr/Tax-Exemptions",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ListTaxExemptions} />
      </Suspense>
  },
  {
    path: "/hr/Tax-Deductions",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ListTaxDeductions} />
      </Suspense>
  },
  {
    path: "/hr/Tax-Declaration",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ListTaxDeclaration} />
      </Suspense>
  },
  {
    path: "/hr/Tax-Calculation",
    element:
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ListTaxCalculation} />
      </Suspense>
  },

  // routes for approval overview pages

  {
    path: "/hr/view-approval-leaves",
    element: <ProtectedRoutes component={ViewApprovalLeaves} />
  }, {
    path: "/hr/view-timesheet",
    element: <ProtectedRoutes component={ViewTimesheets} />
  }, 

  {
    path: "/approvallist-page",
    element: <ProtectedRoutes component={DocumentUserApproval} />
  },

];


const routesForUserAdmin = [
  {
    path: `user-admin-dashboard`,
    element: (
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={AdminDashboard} />
        {/* <ProtectedRoutes component={Home} /> */}
      </Suspense>
    ),
  },
  {
    path: `mail/email-lists`,
    element: (
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={AdminEmailLists} />
      </Suspense>
    ),
  },

  //Licence Page
  {
    path: `licence/list-licence`,
    element: (
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ListLicence} />
      </Suspense>
    ),
  },
  {
    path: `licence/create-licence`,
    element: (
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={CreateLicence} />
      </Suspense>
    ),
  },
  {
    path: `storage/list-storage`,
    element: (
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ListStorage} />
      </Suspense>
    ),
  },
  {
    path: `storage/create-storage`,
    element: (
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={CreateStorage} />
      </Suspense>
    ),
  },
  {
    path: `purchase/list-purchase`,
    element: (
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ListAddonPurchase} />
      </Suspense>
    ),
  },
  {
    path: `purchase/create-purchase`,
    element: (
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={CreateAddonPurchase} />
      </Suspense>
    ),
  },
  {
    path: `plan/cancel-plan`,
    element: (
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={CancelPlans} />
      </Suspense>
    ),
  },
  {
    path: `renewal/list-renewal`,
    element: (
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ListRenewal} />
      </Suspense>
    ),
  },

  //Lookup link
  {
    path: `lookup/list-lookup`,
    element: (
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ListLookup} />
      </Suspense>
    ),
  },
  {
    path: `lookup/create-lookup`,
    element: (
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={CreateLookup} />
      </Suspense>
    ),
  },

  //Task management for useradmin
  {
    path: `task/list-task`,
    element: (
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ListTaskManagement} />
      </Suspense>
    ),
  },
  {
    path: `task/update-task`,
    element: (
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={UpdateTask} />
      </Suspense>
    ),
  },
  {
    path: `task/assign-task`,
    element: (
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={AssignTaskLists} />
      </Suspense>
    ),
  },
  {
    path: `task/calendar-view`,
    element: (
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={TaskCalendarView} />
      </Suspense>
    ),
  },


  //ticket management
  {
    path: `ticket/list-ticket`,
    element: (
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ListTickets} />
      </Suspense>
    ),
  },
  {
    path: `ticket/create-ticket`,
    element: (
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={CreateTickets} />
      </Suspense>
    ),
  },
  {
    path: `ticket/ticket-response`,
    element: (
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={ViewTicketResponse} />
      </Suspense>
    ),
  },
  {
    path: `ticket/Developecreate-ticket`,
    element: (
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={DeveloperTicket} />
      </Suspense>
    ),
  },
  {
    path: `ticket/ticket-Createdticketlist`,
    element: (
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={CreatedTicketList} />
      </Suspense>
    ),
  },
  {
    path: `ticket/ticket-Managementgroup`,
    element: (
      <Suspense fallback={<ERPCustomLoader />}>
        <ProtectedRoutes component={TicketsManagementGroup} />
      </Suspense>
    ),
  },
]

/**
 routes only accessible to authenticated users
 **/
const routesForAuthenticatedOnly = [];

/**
 routes only accessible when user is anonymous
 **/
const routesForNotAuthenticatedOnly = [
  {
    path: "/login",
    element: (
      <Page component={Login} layout={"solo-page"} disableSmLogin={false} />
    ),
  },
  {
    path: "/",
    element: (
      <Page component={Login} layout={"solo-page"} disableSmLogin={true} />
    ),
  },

  {
    path: "/auth-pages/forgot-password",
    element: (
      <Page
        component={ForgotPassword}
        layout={"solo-page"}
        disableSmLogin={true}
      />
    ),
  },
  {
    path: "/auth-pages/forgot-password-form",
    element: (
      <Page
        component={ForgotPasswordForm}
        layout={"solo-page"}
        disableSmLogin={true}
      />
    ),
  },
];

const routes = [
  ...routesForPublic,
  ...routesForUserAdmin,
  ...routesForAuthenticatedOnly,
  ...routesForNotAuthenticatedOnly,
];

export {
  routes as default,
  routesForPublic,
  routesForUserAdmin,
  routesForNotAuthenticatedOnly,
  routesForAuthenticatedOnly,
};
